import { trackPromise } from 'react-promise-tracker';

export async function activateCampaign(campaign, estado, userToken) {
    
    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/activar', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorizationToken': userToken
        },
        body: JSON.stringify({"IDCampana": campaign, "Estado":  estado})
    }).then(data => data.json()))
}